import { withStyles } from "@material-ui/styles";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import QuotationListComponent from './quotation.list';
import QuotationFormComponent from './quotation.form';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const useStyles = (theme) => ({
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '15px 0'
    }
});

function QuotationsComponent(props) {
    const history = useHistory();
    const query = useQuery();

    const { classes } = props;

    const handleOpen = () => {
        history.push("/quotations?mode=create");
    }

    const handleEdit = (row) => {
        history.push(`/quotations/${row.id}?mode=edit`);
    }

    return (
        <div>
            {(() => {
                switch (query.get("mode")) {
                    case 'viewList':
                        return (
                            <QuotationListComponent handleEdit={handleEdit} handleOpen={handleOpen} />
                        );
                    case 'create':
                        return (
                            < QuotationFormComponent />
                        );
                    default:
                        history.push("/quotations?mode=viewList");
                }
            })()}
        </div>
    );
}

export default withStyles(useStyles)(QuotationsComponent);